export default "__VITE_ASSET__CDdHFid2__"